import { useMemo } from 'react'
import { useApiQuery } from '../../../lib/api'
import type { ChatwootCannedResponsesResponse } from '../types'

// Stable reference used as useApiQuery's `startWithValue`, so the placeholder
// identity check (`data === startWithValue`) holds across renders.
const EMPTY_CANNED_RESPONSES: ChatwootCannedResponsesResponse = {
  cannedResponses: [],
}

// Account canned responses for the composer "#" command picker (REQ-03).
export function useChatwootCannedResponses(companyUid?: string | null) {
  const requestData = useMemo(
    () => ({ companyUid: companyUid?.trim() || undefined }),
    [companyUid]
  )

  return useApiQuery<{ companyUid?: string }, ChatwootCannedResponsesResponse>(
    'chatwoot/get_canned_responses',
    {
      data: requestData,
      startWithValue: EMPTY_CANNED_RESPONSES,
    }
  )
}
